"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon3 = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Icon, _Icon2;
var _excluded = ["className", "theme", "name", "type", "placeholder", "testId", "isValid", "isDirty", "isFocused", "autoFocus", "autocomplete", "tabindex", "value", "onEnter", "onFocus", "onBlur", "onChange", "onKeyPress", "validate", "validateOn", "isPending", "setRef", "size", "role", "ariaAtomic", "ariaBusy", "ariaControls", "ariaCurrent", "ariaDescribedby", "ariaDetails", "ariaDisabled", "ariaErrormessage", "ariaFlowto", "ariaHaspopup", "ariaHidden", "ariaInvalid", "ariaKeyshortcuts", "ariaLabel", "ariaLabelledby", "ariaLive", "ariaOwns", "ariaRelevant", "ariaRoledescription", "ariaExpanded"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  autoFocus: false,
  isDirty: false,
  type: 'text',
  placeholder: '',
  onChange: function onChange() {},
  onKeyPress: function onKeyPress() {},
  onEnter: function onEnter() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  theme: {}
};

/**
 * Provides a decorated input text element.
 */
var TextField = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TextField, _React$Component);
  function TextField(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TextField);
    _this = _callSuper(this, TextField, [props]);
    var _this$props = _this.props,
      autoFocus = _this$props.autoFocus,
      value = _this$props.value;
    _this.refInput = _this.refInput.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleScroll = _this.handleScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    _this.togglePassword = _this.togglePassword.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      showPassword: false,
      autoFocusState: autoFocus,
      value: value
    };
    return _this;
  }
  (0, _createClass2["default"])(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = this.textInput;
      var _this$props2 = this.props,
        value = _this$props2.value,
        type = _this$props2.type,
        autoFocus = _this$props2.autoFocus;
      if (node && type === 'number') {
        node.addEventListener('wheel', this.handleScroll);
      }

      // controlled input autofocus in modal (which injected into the DOM dynamically)
      if (autoFocus) {
        setTimeout(function () {
          // If input has a predefined value, then focus operation will set
          // cursor before the text.
          // We need manually clear input value before doing focus
          // and restore the value after it.
          // It will set cursor to the end of the text.
          var nodeValue = node.value;
          node.value = '';
          node.focus();
          node.value = nodeValue;
        });
      }
      if (!node || !value) {
        return;
      }
      if (type === 'number') {
        node.value = value.toString();
      } else {
        node.value = value;
      }
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "togglePassword",
    value: function togglePassword() {
      var showPassword = this.state.showPassword;
      this.setState({
        showPassword: !showPassword
      });
    }
  }, {
    key: "refInput",
    value: function refInput(input) {
      this.textInput = input;
      if (this.props.setRef && typeof this.props.setRef === 'function') {
        this.props.setRef(input);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(evt) {
      if (this.textInput && this.textInput.type === 'number') {
        this.textInput.addEventListener('wheel', this.handleScroll);
      }
      var onFocus = this.props.onFocus;
      this.setState({
        autoFocusState: true
      });
      onFocus(evt);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(evt) {
      if (this.textInput && this.textInput.type === 'number') {
        this.textInput.removeEventListener('wheel', this.handleScroll);
      }
      var onBlur = this.props.onBlur;
      this.setState({
        autoFocusState: false
      });
      onBlur(evt);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var _this2 = this;
      // this is to prevent number fields from changing while scrolling
      if (this.state.autoFocusState) {
        this.textInput.blur();
        setTimeout(function () {
          _this2.textInput.focus();
        }, 10);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var newValue = '';
      var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        type = _this$props3.type;
      var target = e.target;
      var match = target.value.match(/^-?\d+(\.\d+)?/g) || [''];
      if (type !== 'number') {
        newValue = target.value;
      }
      if (type === 'number' && match) {
        newValue = match[0];
      }
      var newState = {
        value: newValue
      };
      this.setState(newState, function () {
        return onChange(newState);
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props4 = this.props,
        onKeyPress = _this$props4.onKeyPress,
        onEnter = _this$props4.onEnter;
      onKeyPress(e);
      if (e.key === 'Enter') {
        onEnter({
          value: e.target.value
        });
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var onChange = this.props.onChange;
      var newState = {
        value: '',
        isClear: true
      };
      this.setState(newState, function () {
        return onChange(newState);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        className = _this$props5.className,
        theme = _this$props5.theme,
        name = _this$props5.name,
        type = _this$props5.type,
        placeholder = _this$props5.placeholder,
        testId = _this$props5.testId,
        isValid = _this$props5.isValid,
        isDirty = _this$props5.isDirty,
        isFocused = _this$props5.isFocused,
        autoFocus = _this$props5.autoFocus,
        autocomplete = _this$props5.autocomplete,
        tabindex = _this$props5.tabindex,
        value = _this$props5.value,
        onEnter = _this$props5.onEnter,
        onFocus = _this$props5.onFocus,
        onBlur = _this$props5.onBlur,
        onChange = _this$props5.onChange,
        onKeyPress = _this$props5.onKeyPress,
        validate = _this$props5.validate,
        validateOn = _this$props5.validateOn,
        isPending = _this$props5.isPending,
        setRef = _this$props5.setRef,
        size = _this$props5.size,
        role = _this$props5.role,
        ariaAtomic = _this$props5.ariaAtomic,
        ariaBusy = _this$props5.ariaBusy,
        ariaControls = _this$props5.ariaControls,
        ariaCurrent = _this$props5.ariaCurrent,
        ariaDescribedby = _this$props5.ariaDescribedby,
        ariaDetails = _this$props5.ariaDetails,
        ariaDisabled = _this$props5.ariaDisabled,
        ariaErrormessage = _this$props5.ariaErrormessage,
        ariaFlowto = _this$props5.ariaFlowto,
        ariaHaspopup = _this$props5.ariaHaspopup,
        ariaHidden = _this$props5.ariaHidden,
        ariaInvalid = _this$props5.ariaInvalid,
        ariaKeyshortcuts = _this$props5.ariaKeyshortcuts,
        ariaLabel = _this$props5.ariaLabel,
        ariaLabelledby = _this$props5.ariaLabelledby,
        ariaLive = _this$props5.ariaLive,
        ariaOwns = _this$props5.ariaOwns,
        ariaRelevant = _this$props5.ariaRelevant,
        ariaRoledescription = _this$props5.ariaRoledescription,
        ariaExpanded = _this$props5.ariaExpanded,
        props = (0, _objectWithoutProperties2["default"])(_this$props5, _excluded);
      var _this$state = this.state,
        valueToUse = _this$state.value,
        showPassword = _this$state.showPassword;
      var finalType = showPassword ? 'text' : type;
      var isFocusedStatus;
      switch (isFocused) {
        case true:
          isFocusedStatus = isFocused;
          break;
        case false:
          isFocusedStatus = isFocused;
          break;
        default:
          isFocusedStatus = this.state.autoFocusState;
      }
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, isDirty ? theme['is-dirty'] : '', isValid ? theme['is-valid'] : '', isValid === false ? theme['has-error'] : '', isFocusedStatus ? theme['is-focused'] : '', type === 'password' ? theme['is-password-type'] : '', theme['text-field'], size ? theme["form-size-".concat(size)] : ''),
        "data-test-id": testId,
        "data-anypoint-component": TextField.displayName
      }, type === 'search' ? /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId && "search-text-field-input-".concat(testId),
        className: theme.search
      }, _Icon || (_Icon = /*#__PURE__*/_react["default"].createElement(_Icon3["default"], {
        name: "search",
        size: "xs",
        isDecorative: true
      }))) : null, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
        ref: this.refInput,
        "data-test-id": testId && "".concat(testId, "-input"),
        name: name,
        type: finalType,
        value: valueToUse,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        placeholder: placeholder,
        tabIndex: tabindex,
        autoComplete: autocomplete,
        autoFocus: autoFocus,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-busy": ariaBusy,
        "aria-controls": ariaControls
        /* eslint-disable-next-line jsx-a11y/aria-props */,
        "aria-current": ariaCurrent,
        "aria-describedby": ariaDescribedby
        /* eslint-disable-next-line jsx-a11y/aria-props */,
        "aria-details": ariaDetails,
        "aria-disabled": ariaDisabled
        /* eslint-disable-next-line jsx-a11y/aria-props */,
        "aria-errormessage": ariaErrormessage,
        "aria-flowto": ariaFlowto,
        "aria-haspopup": ariaHaspopup,
        "aria-hidden": ariaHidden,
        "aria-invalid": ariaInvalid
        /* eslint-disable-next-line jsx-a11y/aria-props */,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-live": ariaLive,
        "aria-owns": ariaOwns,
        "aria-relevant": ariaRelevant
        /* eslint-disable-next-line jsx-a11y/aria-props */,
        "aria-roledescription": ariaRoledescription,
        "aria-expanded": ariaExpanded
      }, props)), type === 'password' && valueToUse ? /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.togglePassword,
        className: theme['show-hide-password'],
        "data-test-id": testId && "".concat(testId, "-show-hide-password"),
        type: "button"
      }, showPassword ? 'Hide' : 'Show') : null, type === 'search' && valueToUse ? /*#__PURE__*/_react["default"].createElement("button", {
        className: theme.clear,
        "data-test-id": testId && "clear-text-field-input-".concat(testId),
        "aria-label": "Clear Search",
        onClick: this.handleClear,
        type: "button"
      }, _Icon2 || (_Icon2 = /*#__PURE__*/_react["default"].createElement(_Icon3["default"], {
        name: "close-small",
        size: "xs",
        isDecorative: true
      }))) : null);
    }
  }]);
  return TextField;
}(_react["default"].Component);
(0, _defineProperty2["default"])(TextField, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(TextField, "displayName", 'TextField');
//# sourceMappingURL=TextField.js.map